import { Grid } from '@mui/material';
import { isDef } from '@utils/def';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import FormField from '../../../FormField';
import { InputTypes, Sizes } from '../../../Input';

import { FormFieldNumberValueType, FormFields } from '../../types';
import { getGridColumnAmount, getValidationRulesFromAField } from '../../utils';

import { StyledInput, StyledMeasuringUnitInput } from './styles';
import { Props } from './types';

const FormNumberRenderer: FC<Props> = ({ field }) => {
  const { control } = useFormContext<FormFields>();
  const validationRules = useMemo(
    () => getValidationRulesFromAField(field),
    [field],
  );
  const gridColumnAmount = useMemo(
    () => getGridColumnAmount(field.columnsAmount),
    [field.columnsAmount],
  );
  const gridOffsetColumnAmount = useMemo(
    () =>
      isDef(field.offsetColumnsAmount)
        ? getGridColumnAmount(field.offsetColumnsAmount)
        : undefined,
    [field.offsetColumnsAmount],
  );

  return (
    <>
      <Grid item xs={gridColumnAmount}>
        <FormField
          {...validationRules}
          defaultValue={field.defaultValue}
          controllerProps={{
            control,
            name: field.name,
          }}
          render={(props) => {
            const inputProps = {
              ...props,
              disabled: field.disabled,
              error: props.error,
              extraRightContent: field.extraRightContent,
              label: field.label,
              loading: field.loading,
              required: field.required,
              placeholder: field.placeholder,
              prefix: field.prefix,
              postfix: field.postfix,
              showLabel: field.showLabel,
              size: field.size as unknown as Sizes,
              type: InputTypes.number,
              value: props.value as FormFieldNumberValueType,
              step: field.step,
              readOnly: field.readOnly,
            };

            return field.measuringUnit ? (
              <StyledMeasuringUnitInput
                {...inputProps}
                measuringUnit={field.measuringUnit}
              />
            ) : (
              <StyledInput {...inputProps} />
            );
          }}
        />
      </Grid>
      {isDef(gridOffsetColumnAmount) && (
        <Grid item xs={gridOffsetColumnAmount} />
      )}
    </>
  );
};

export default FormNumberRenderer;
